import $ from 'jquery';
import shoppableImages from './shoppableImages';

export default () => {

  // if (window.location.pathname.indexOf('/blogs/test') === -1) {
  //   return;
  // }


  $('.BlogNav__select').val(window.location.pathname);
  const pathName = window.location.pathname.split('/tagged/');
  if (pathName[1]) {
    $(`#${pathName[1]}`).addClass('BlogNav--select');
  } else {
    $('#view-all').addClass('BlogNav--select');
  }

  $('.BlogNav__select').change((e) => {
    const option = $(e.currentTarget).val();
    window.location.href = option;
  });

  shoppableImages();  
}; 